import { Element } from 'react-scroll';

import { Separator } from '@components/formStyles';
import BannerDetail, {
  BannerDetailCarousel,
} from '@components/views/hotel/listing/components/Banner/BannerDetail';
import { BannerDetailWrapper } from '@components/views/hotel/listing/components/Banner/BannerStyle';
import { useDevice } from '@contexts/device';
import { DetailPageBannerViewModel } from '@api/v3';

const HotelBanners = ({
  data,
  showNormalHotel,
  scrollToBottom,
  handleNavigateAnnouncment,
}: {
  data?: DetailPageBannerViewModel;
  showNormalHotel: boolean;
  scrollToBottom: () => void;
  handleNavigateAnnouncment: () => void;
}) => {
  const { isDesktop } = useDevice();
  return (
    <>
      {((data?.images || data?.responsiveImages) && showNormalHotel) ||
      data?.announcements ? (
        <>
          <Separator />
          <Element name='announcements' className='element'>
            {data?.announcements.length > 0 ? (
              <BannerDetailCarousel
                data={data?.announcements}
                onClick={() => scrollToBottom()}
              />
            ) : (
              <>
                {isDesktop && data ? (
                  <>
                    {data?.images?.[0]?.url ? (
                      <BannerDetailWrapper onClick={handleNavigateAnnouncment}>
                        <BannerDetail
                          url={data?.images[0]?.url}
                          alt={data?.images[0]?.alt}
                        />
                      </BannerDetailWrapper>
                    ) : null}
                  </>
                ) : (
                  <>
                    {data?.responsiveImages[0]?.url ? (
                      <BannerDetailWrapper onClick={handleNavigateAnnouncment}>
                        <BannerDetail
                          url={data?.responsiveImages[0]?.url}
                          alt={data?.responsiveImages[0]?.alt}
                        />
                      </BannerDetailWrapper>
                    ) : null}
                  </>
                )}
              </>
            )}
          </Element>
        </>
      ) : null}
    </>
  );
};

export default HotelBanners;
